import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useWebServer } from "../../../../../providers/WebServerProvider";
import { useHistory } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";
import {
  fetchCollectionMethod,
  deleteCollectionMethod,
} from "../../../../../actions";
import DataTableCM from "../../../../DataTable/DataTableCM";

const columns = [
  {
    field: "displayName",
    label: "Name",
    isSortable: true,
    align: "left",
    sx: {
      whiteSpace: "nowrap",
      // minWidth: "4rem", width: '100%', maxWidth: "200px"
    },
  },
  // {
  //   field: "vectorType",
  //   label: "Vector Type",
  //   isSortable: true,
  //   align: "left",
  //   sx: { maxWidth: "90px" },
  // },
  {
    field: "trapType",
    label: "Trap Type",
    isSortable: true,
    align: "left",
    sx: {
      // minWidth: "6rem",
      // width: "7rem",
      // maxWidth: "10rem",
      // overflow: "scroll",
      // textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  {
    field: "attractantType",
    label: "Attractants",
    isSortable: true,
    align: "center",
    sx: {
      //  minWidth: "6rem", width: "7rem",
      whiteSpace: "nowrap",
    },
    render: (row) =>
      Array.isArray(row.attractantType)
        ? row.attractantType.join(", ")
        : row.attractantType || "",
  },
  // {
  //   field: "description",
  //   label: (
  //     <div>
  //       Desc
  //     </div>
  //   ),
  //   isSortable: true,
  //   align: "center",
  //   sx: { maxWidth: "100px" },
  // },
];

const options = {
  allowCreate: true,
  allowClick: true,
};

const buttonStyles = {
  infoButton: {
    color: "status.info",
  },
  editButton: {
    "&:hover, &:focus": {
      color: "status.info",
    },
  },
  deleteButton: {
    "&:hover, &:focus": {
      color: "status.danger",
    },
  },
};

const Index = ({
  collectionMethods,
  count,
  page,
  pageSize,
  order,
  orderBy,
  fetchCollectionMethod,
  deleteCollectionMethod,
}) => {
  const { sendRequest } = useWebServer();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [collectionMethodsData, setCollectionMethodsData] = useState([]);

  const handleEditCollectionMethod = (rowData) => {
    history.push(ROUTES.editCollectionMethod.replace(":id", rowData.id));
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await handleFetchCollectionMethod();
      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, orderBy, order]);

  useEffect(() => {
    setCollectionMethodsData(collectionMethods);
  }, [collectionMethods]);

  const handleAddCollectionMethods = () => {
    history.push(ROUTES.createCollectionMethod);
  };

  const handleDeleteCollectionMethod = async (row) => {
    await deleteCollectionMethod(row.id, sendRequest);
  };

  const handleFetchCollectionMethod = async () => {
    await fetchCollectionMethod({}, sendRequest);
  };

  // console.log("collection method list", collectionMethods);

  return (
    <div id={"collection-methods"}>
      <DataTableCM
        dataList={collectionMethodsData}
        total={count || 0}
        tableName={"Collection Method"}
        columns={columns}
        isFetchingData={loading}
        handleAddData={handleAddCollectionMethods}
        options={options}
        actions={[
          {
            name: "Edit",
            icon: EditIcon,
            position: "primary",
            dialog: null,
            sx: buttonStyles.editButton,
            handler: handleEditCollectionMethod,
          },
          {
            name: "Delete",
            icon: DeleteIcon,
            position: "primary",
            dialog: (row) =>
              `Are you sure you want to delete Collection Detail ${row.displayName}?\nThis action can not be undone`,
            sx: buttonStyles.deleteButton,
            handler: handleDeleteCollectionMethod,
          },
        ]}
        onClickRow={(row) => {}}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { page, pageSize, order, orderBy } =
    state?.settings?.["Collection Method"];
  const { count, ...collectionMethods } = state?.collectionMethods;
  return {
    collectionMethods: Object.values(collectionMethods),
    count,
    page,
    pageSize,
    order,
    orderBy,
  };
};

export default connect(mapStateToProps, {
  fetchCollectionMethod,
  deleteCollectionMethod,
})(Index);
